/* eslint-disable no-magic-numbers */
import moment from 'moment';
import { useContext, useEffect } from 'react';
import { FeatureFlagsContext } from '../context';
export function useWWOOBanner() {
  const {
    NEXT_PUBLIC_FEAT_FLAG_WWOO_BANNER: flag
  } = useContext(FeatureFlagsContext);
  useEffect(() => {
    if (true && flag) {
      if (moment().isBetween(moment('2022-11-22 00:05:00.000+11:00'), moment('2022-11-28 23:55:00.000+11:00'))) {
        const bigGif = 'https://cam.scentregroup.io/m/2a84f981712b517b';
        const smallGif = 'https://cam.scentregroup.io/m/4a85439b122b7034';
        const barId = 'wwoo-offers-2';
        const localStorageKey = "".concat(barId, "-bar-last-closed");
        const elementKey = "".concat(barId, "-alert-bar");
        const bannerBig = "<a href=\"https://www.westfield.com.au/explore/sale\" aria-hidden><img style=\"height: 50px\" src=\"https://images.scentregroup.io/image/fetch/q_auto,f_auto/".concat(bigGif, "\" aria-hidden></a>");
        const bannerSmall = "<a href=\"https://www.westfield.com.au/explore/sale\" aria-hidden><img src=\"https://images.scentregroup.io/image/fetch/q_auto,f_auto/".concat(smallGif, "\" aria-hidden></a>");
        const ls = window.sessionStorage;
        const lastClosed = ls.getItem(localStorageKey);

        if ((!lastClosed || moment(lastClosed).isAfter(moment())) && !document.body.contains(document.querySelector("#".concat(elementKey)))) {
          const barContainer = document.createElement('div');
          barContainer.setAttribute('aria-role', 'complementary');
          barContainer.setAttribute('id', elementKey);
          barContainer.style.position = 'fixed';
          barContainer.style.bottom = '0px';
          barContainer.style.left = '0px';
          barContainer.style.right = '0px';
          barContainer.style.backgroundColor = '#161616';
          barContainer.style.display = 'flex';
          barContainer.style.alignItems = 'center';
          barContainer.style.width = '100%';
          const barInner = document.createElement('div');
          barInner.style.textAlign = 'center';
          barInner.style.display = 'flex';
          barInner.style.width = '100%';
          barInner.style.justifyContent = 'center';
          const exitIcon = document.createElement('button');
          exitIcon.style.position = 'absolute';
          exitIcon.style.width = '16px';
          exitIcon.style.height = '16px';
          exitIcon.style.color = 'white';
          exitIcon.addEventListener('click', () => {
            ls.setItem(localStorageKey, moment().format());
            barContainer.remove();
          });

          if (window.innerWidth >= 768) {
            barContainer.style.height = '50px';
            exitIcon.style.top = '17px';
            exitIcon.style.right = '24px';
            barInner.innerHTML = bannerBig;
          } else {
            barContainer.style.height = '50px';
            exitIcon.style.top = '17px';
            exitIcon.style.right = '11px';
            barInner.innerHTML = bannerSmall;
          }

          const exitIconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          exitIconSvg.innerHTML = '<path d="M4.47 4.47l15.012 15.012m0-15.012L4.471 19.483" fill="none" stroke-linecap="square" stroke-linejoin="round" stroke="currentColor" stroke-width="2"></path>';
          exitIconSvg.setAttribute('viewBox', '0 0 24 24');
          exitIcon.replaceChildren(exitIconSvg);
          barContainer.replaceChildren(barInner, exitIcon);
          document.body.appendChild(barContainer);
          const htmlEl = document.querySelector('html');
          const bodyEl = document.querySelector('body');

          if (htmlEl && bodyEl) {
            htmlEl.style.setProperty('-webkit-overflow-scrolling', 'unset');
            bodyEl.style.setProperty('-webkit-overflow-scrolling', 'unset');
          }
        }
      }
    }
  }, [flag]);
}